import { render, staticRenderFns } from "./ui-alert.vue?vue&type=template&id=3d11ef8d"
import script from "./ui-alert.vue?vue&type=script&lang=js"
export * from "./ui-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports